// @ts-check
export const FIXED_STEP = 1 / 120;
/** A fixed simulation clock. Excess time is discarded after a stall, never repaid as a teleport.
 * @param {(seconds:number)=>void} step
 * @param {{fixedStep?:number,maxSteps?:number}} [options]
 */
export function createClock(step, { fixedStep = FIXED_STEP, maxSteps = 6 } = {}) {
  if (!(fixedStep > 0) || !Number.isFinite(fixedStep) || !Number.isInteger(maxSteps) || maxSteps < 1) throw new RangeError('Invalid simulation clock');
  let accumulator = 0;
  let ticks = 0;
  let droppedSeconds = 0;
  return {
    /** @param {number} seconds */
    advance(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return 0;
      const accepted = Math.min(seconds, fixedStep * maxSteps);
      droppedSeconds += seconds - accepted;
      accumulator += accepted;
      let count = 0;
      while (accumulator + 1e-10 >= fixedStep && count < maxSteps) {
        step(fixedStep); accumulator = Math.max(0, accumulator - fixedStep); count++; ticks++;
      }
      return count;
    },
    reset() { accumulator = 0; },
    get alpha() { return accumulator / fixedStep; },
    get stats() { return { ticks, droppedSeconds }; },
  };
}
